import { ILog, IStatus, ITrack, IAnchorCircle, IAuditLogEdit, IDay } from "../../Types"
import { DayWriters } from "../../App/Context"
import { createViewData } from "../../App/ViewData"

// The data-acquisition layer's assembled value for DayView's presentational
// component (`DayViewUI`), read via `useDayData()`. Populated by whichever
// `DayDataView*` variant is currently mounted (legacy today; a new data-model
// variant in a later PR) -- `DayViewUI` never knows or cares which one it is.
export interface DayDataViewData {
  logs: ILog[] | undefined;
  statuses: IStatus[] | undefined;
  tracks: ITrack[] | undefined;
  anchorCircles: IAnchorCircle[] | undefined;
  auditLogEdits: IAuditLogEdit[];
  // Committed `logs` merged with any in-progress provisional logs, sorted by time --
  // what the timeline/day-edit views actually render.
  timelineLogs: ILog[];
  recordAuditLogEdits: (edits: IAuditLogEdit[]) => void;
  savedDay: IDay | undefined;
  recordSavedDay: (day: IDay) => void;

  // The write surface DayView's edit sub-views call (via `GetDay()`), owned by the
  // acquisition variant: the New variant provides store-backed optimistic writers,
  // the Legacy variant plain typed-REST pass-throughs (#1165, tracker #665). `DayViewUI`
  // spreads these onto the descendant `DayContext` it provides.
  writers: DayWriters;

  // Pure UI state that nonetheless gates data acquisition (e.g. `loadLogs` only runs
  // once `selected`, `loadTrack` only once `details`) -- owned by the acquisition
  // variant for that reason, exposed here so `DayViewUI` can render/toggle it without
  // needing its own local state.
  details: boolean;
  setDetails: (value: boolean) => void;
  selected: boolean;
  toggleSelected: () => void;
  highlight: number | undefined;
  clearHighlight: () => void;
  // Invoked by the tab bar when the "track" tab is selected -- lazily loads the
  // track/anchor-circle data for the current day the first time it's shown.
  selectedCallback: (value?: string) => Promise<void>;
}

export const { Context: DayDataContext, useData: useDayData } = createViewData<DayDataViewData>("DayDataView");
